import React from 'react';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { getSeoFooterData } from '../../../utils/plpMetaInfo.js';
import { getRuntimeBannersFlag } from '../../../Flags/selectors';

const FooterForSEO = ({
  metaElementData = [],
  runtimeBanners,
  isRuntimeBannerPage,
  plpTopBrands = [],
  plpTopBricks = [],
  plpTopProducts = [],
  topProductHeader = ''
}) => {
  const topBrands = getSeoFooterData(
    metaElementData,
    isRuntimeBannerPage ? 'topBrands' : 'brands',
    isRuntimeBannerPage ? 'ON' : 'OFF'
  );
  const topSearches = getSeoFooterData(
    metaElementData,
    isRuntimeBannerPage ? 'topSearches' : 'searches',
    isRuntimeBannerPage ? 'ON' : 'OFF'
  );
  const bottomDescrip = getSeoFooterData(
    metaElementData,
    isRuntimeBannerPage ? 'bottomDescription' : 'bottomDesc',
    isRuntimeBannerPage ? 'ON' : 'OFF'
  );
  if (
    _isEmpty(plpTopBrands) &&
    _isEmpty(topSearches) &&
    _isEmpty(bottomDescrip) &&
    _isEmpty(plpTopBricks) &&
    _isEmpty(plpTopProducts)
  ) {
    return null;
  }
  const getTopProductWithPrice = (topProduct = []) => {
    return topProduct.map(item => (
      <a href={item.productUrl}>
        <div className="productName">{item.productName}</div>
        <div className="productPrice">Rs. {item.listPrice}</div>
      </a>
    ));
  };
  const getPlpTopBrandsBrickDom = (plpTopBrands = []) => {
    return plpTopBrands.map((item, index) => (
      <>
        <a href={item.brandUrl || item.brickUrl}>
          <span className="brandName">{item.brandName || item.brickName}</span>
        </a>
        <span>&nbsp;{index !== plpTopBrands.length - 1 ? '/' : ''} </span>
      </>
    ));
  };

  const currentDate = new Date();
  const finalDate = `${currentDate.toLocaleDateString(undefined, {
    month: 'short'
  })} ${currentDate.toLocaleDateString(undefined, {
    day: '2-digit'
  })}, ${currentDate.toLocaleDateString(undefined, { year: 'numeric' })}`;

  return (
    <div className="seo-footer-desktop">
      <div className="ftr-align-center">
        <div className="dekstop-footer-content">
          {/* {!_isEmpty(topBrands) && <div dangerouslySetInnerHTML={{ __html: topBrands }}></div>} */}
          {!_isEmpty(plpTopBrands) && Array.isArray(plpTopBrands) && (
            <div className="plpTopBrandsBrick">
              <h2>TOP BRANDS</h2>
              {getPlpTopBrandsBrickDom(plpTopBrands)}
            </div>
          )}
          {!_isEmpty(plpTopBricks) && Array.isArray(plpTopBricks) && (
            <div className="plpTopBrandsBrick">
              <h2>TOP CATEGORIES</h2>
              {getPlpTopBrandsBrickDom(plpTopBricks)}
            </div>
          )}
          {!_isEmpty(topSearches) && !Array.isArray(topSearches) && (
            <div dangerouslySetInnerHTML={{ __html: topSearches }} />
          )}
          {!_isEmpty(bottomDescrip) && <div dangerouslySetInnerHTML={{ __html: bottomDescrip }} />}
        </div>
        {plpTopProducts.length ? (
          <div className="topProduct">
            <h1>{topProductHeader} PRICE LIST</h1>
            <div className="productHeader">
              <div className="productNameHeader">{topProductHeader}</div>
              <div className="productPriceHeader">Price (Rs.)</div>
            </div>
            <div className="productData">{getTopProductWithPrice(plpTopProducts)}</div>
            <div className="lastUpdateProduct">Last updated on {finalDate}</div>
          </div>
        ) : null}
      </div>
      <div className="seo-ftr-btm-brdr" />
    </div>
  );
};

const mapStateToProps = state => {
  const { productsAdditionalInfo = {}, flags = {}, bannerInfo = {} } = state;
  const {
    metaElementData = [],
    topBrands = [],
    topBricks = [],
    topProducts = [],
    categoryforheader = '',
    categoryName = ''
  } = productsAdditionalInfo;
  const topProductHeader = `${categoryforheader.charAt(0).toUpperCase() +
    categoryforheader.slice(1).toLowerCase()} ${categoryName}`;
  return {
    metaElementData,
    runtimeBanners: getRuntimeBannersFlag(flags),
    isRuntimeBannerPage: bannerInfo.isRuntimeBannerPage,
    plpTopBrands: topBrands,
    plpTopBricks: topBricks,
    plpTopProducts: topProducts,
    topProductHeader
  };
};

export default connect(mapStateToProps)(FooterForSEO);
